(function () {
  const SELECTOR = '[data-mobile-menu-tabs]';

  const activateTab = (container, index) => {
    const tabs = container.querySelectorAll('[data-tab-trigger]');
    const panels = container.querySelectorAll('[data-tab-panel]');

    tabs.forEach((tab, i) => {
      const isActive = i === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach((panel, i) => {
      const isActive = i === index;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  };

  const initMobileMenuTabs = (scope) => {
    const root = scope || document;
    root.querySelectorAll(SELECTOR).forEach((container) => {
      if (container.dataset.tabsInitialized === 'true') return;
      container.dataset.tabsInitialized = 'true';

      const tabs = container.querySelectorAll('[data-tab-trigger]');
      const startIndex = parseInt(container.dataset.startIndex || '0', 10);

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          activateTab(container, parseInt(tab.dataset.tabTrigger, 10));
        });
      });

      activateTab(container, Number.isNaN(startIndex) ? 0 : startIndex);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initMobileMenuTabs());
  document.addEventListener('shopify:section:load', (event) => initMobileMenuTabs(event.target));
})();
